import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("user");
      if (token && userData) {
        setUser({ ...JSON.parse(userData), token });
      }
    } catch {
      // corrupted storage — treat as logged out
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } finally {
      setLoading(false);
    }
  }, []);

  // Call this from Login.jsx — replaces your persistSession()
  const login = (token, userData) => {
    // mirrors your existing persistSession logic exactly
    localStorage.setItem("token",    token);
    localStorage.setItem("user",     JSON.stringify(userData));
    localStorage.setItem("th_token", token);
    localStorage.setItem("th_user",  JSON.stringify(userData));
    setUser({ ...userData, token });
  };

  // Call this from Signup — mirrors your existing localStorage.setItem calls
  const loginAfterSignup = (token, userData) => {
    login(token, userData); // reuse same logic
  };

  const logout = () => {
    ["token", "user", "th_token", "th_user",
     "th_employer_token", "th_employer"].forEach(k =>
      localStorage.removeItem(k)
    );
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, loginAfterSignup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);